// extracted by mini-css-extract-plugin
export default {"root":"Nqj7B","submit":"yMhpY"};